import { Umbrella } from 'lucide-react';
import { msg } from '@/lib/i18n';
import { registerInvalidation } from '@/lib/realtime';
import { registerEntityHref } from '@/ui';
import { defineModule } from '../types';
import { insuranceKeys } from './api';
import { claimRoute, claimsRoute, coachingRoute, driversRoute, insuranceRoute } from './routes';

/** Insurance: the insurer's view of insured fleets — risk, drivers, coaching impact — and claims. */
export const insuranceModule = defineModule({
  key: 'insurance',
  routes: [insuranceRoute, driversRoute, coachingRoute, claimsRoute, claimRoute],
  nav: [
    {
      key: 'insurance',
      label: msg('Insurance'),
      description: msg('What is the risk?'),
      icon: Umbrella,
      to: '/insurance',
      section: 'improve',
      order: 70,
      module: 'insurance',
      permission: ['insurance.risk.read', 'insurance.claim.read'],
      match: ['/insurance'],
      children: [
        { key: 'drivers', label: msg('Drivers by risk'), to: '/insurance/drivers', permission: 'insurance.risk.read' },
        { key: 'coaching', label: msg('Coaching impact'), to: '/insurance/coaching', permission: 'insurance.risk.read' },
        { key: 'claims', label: msg('Claims'), to: '/insurance/claims', permission: 'insurance.claim.read' },
      ],
    },
  ],
  setup() {
    registerEntityHref('claim', (id) => `/insurance/claims/${id}`);
    // Claim events are about the vehicle (or the claim when there is none).
    registerInvalidation('claim', () => [insuranceKeys.all]);
    registerInvalidation('vehicle', (n) => (n.type.startsWith('insurance.') ? [insuranceKeys.all] : []));
  },
});
